import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Caption } from '@root/src/web/components/Caption';
export const SpotifyBlockComponent = ({ embedUrl, width, height, title, format, palette, caption, credit }) => {
    const embedContainer = css `
		iframe {
			width: 100%;
		}
		margin-bottom: 16px;
	`;
    return (_jsx(_Fragment, { children: embedUrl && title && width && height && (_jsxs("div", Object.assign({ css: embedContainer, "data-cy": "spotify-embed" }, { children: [_jsx("iframe", { src: embedUrl, title: title, height: height, width: width, allowFullScreen: true }, void 0),
                caption && (_jsx(Caption, { captionText: caption, format: format, palette: palette, credit: credit }, void 0))] }), void 0)) }, void 0));
};
